/***************************************************************************
 * NO JS
 * This script will remove the 'noJs' class name from the
 * tx_eventmanagement element. When the 'noJs' class is set then extra css
 * will be loaded to ensure the usage without javascript.
 **************************************************************************/

/**
 * SET REMOVE NO JS CLASS NAME
 *
 * This function will remove
 * the noJs class name from
 * all tx_eventmanagement
 * elements.
 *
 * @requires undefined
 *
 * @return DOM
 */
function setRemoveNoJsClassName() {
    var arrayOfTxEventManagementForms = document.getElementsByClassName('tx_eventmanagement');
    for (var txEventManagementForm = 0; txEventManagementForm < arrayOfTxEventManagementForms.length; txEventManagementForm++) {
        if (arrayOfTxEventManagementForms[txEventManagementForm].classList.contains('tx_eventmanagement--noJs')) {
            arrayOfTxEventManagementForms[txEventManagementForm].classList.remove('tx_eventmanagement--noJs');
        }
    }
}


// Execute functions
document.addEventListener('DOMContentLoaded', function() {
    setRemoveNoJsClassName();
});